import * as React from "react";
import { Sparkles } from "lucide-react";
import { Combobox } from "@/components/ui";
import { cn } from "@/lib/utils";
import { PromptKind } from "@/containers/Coach/Library/PromptsTab/promptKind";

export interface PromptKindFilterProps {
  value: PromptKind;
  onChange: (kind: PromptKind) => void;
  audience: "coach" | "player";
  className?: string;
}

type KindItem = { value: PromptKind; label: string; icon?: React.ReactNode };

const LABELS: Record<PromptKindFilterProps["audience"], Record<PromptKind, string>> = {
  coach: { ALL: "All prompts", STATIC: "Static prompts", DYNAMIC: "Dynamic prompts" },
  player: { ALL: "All prompts", STATIC: "Standard prompts", DYNAMIC: "Personalized prompts" },
};

export const PromptKindFilter: React.FC<PromptKindFilterProps> = ({ value, onChange, audience, className }) => {
  const items: KindItem[] = React.useMemo(() => {
    const labels = LABELS[audience];
    return [
      { value: "ALL", label: labels.ALL },
      { value: "STATIC", label: labels.STATIC },
      { value: "DYNAMIC", label: labels.DYNAMIC, icon: <Sparkles className="size-3.5" aria-hidden="true" /> },
    ];
  }, [audience]);
  const selected = items.find(item => item.value === value) ?? items[0];

  return (
    <Combobox
      items={items}
      value={selected}
      onValueChange={item => onChange((item ?? selected).value)}
      isItemEqualToValue={(item, current) => item.value === current?.value}
      placeholder={LABELS[audience].ALL}
      className={cn("max-w-40 min-w-40", className)}
    />
  );
};
